import { render, staticRenderFns } from "./approveDialog.vue?vue&type=template&id=2644eeb5"
import script from "./approveDialog.vue?vue&type=script&lang=js"
export * from "./approveDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports